import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Instagram, Music2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SocialFeed() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/social/posts`).then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  if (!posts || posts.length === 0) return null;

  return (
    <section className="py-20 lg:py-28 bg-[#faf9f7]" data-testid="social-feed-section">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-wrap items-end justify-between gap-6 mb-12"
        >
          <div>
            <div className="font-tech text-[11px] tracking-[0.3em] text-[#f97316] uppercase mb-4">From the field</div>
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl text-[#17150f]" data-testid="social-feed-headline">
              Latest from NOXWAY
            </h2>
          </div>
          <div className="flex gap-3">
            <a href="https://www.instagram.com/noxway888" target="_blank" rel="noreferrer" data-testid="feed-instagram-link"
              className="inline-flex items-center gap-2 text-xs font-medium text-stone-500 hover:text-[#f97316] transition-colors">
              <Instagram size={14} /> @noxway888
            </a>
            <a href="https://www.tiktok.com/@noxway888" target="_blank" rel="noreferrer" data-testid="feed-tiktok-link"
              className="inline-flex items-center gap-2 text-xs font-medium text-stone-500 hover:text-[#f97316] transition-colors">
              <Music2 size={14} /> @noxway888
            </a>
          </div>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="social-feed-grid">
          {posts.map((p, i) => (
            <motion.div
              key={p.embed_url}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="rounded-xl border border-stone-200 bg-white overflow-hidden shadow-sm"
              data-testid={`social-post-${i}`}
            >
              <iframe
                src={p.embed_url}
                title={p.caption || `${p.platform} post`}
                className="w-full aspect-[4/5] border-0"
                loading="lazy"
                allowFullScreen
                allow="encrypted-media"
              />
              {p.caption && <p className="text-xs text-stone-500 px-4 py-3 border-t border-stone-100">{p.caption}</p>}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
